/*
 * Announcement bar behaviour.
 *
 * Two jobs only: swap between the rotating promises and the ladder line when
 * the cart stops or starts being empty, and open the cart drawer on click. All
 * the numbers arrive on the `cp:ladder` event from cp-ladder-ui.js — this file
 * never reads the cart and never does arithmetic.
 */
import { CP_LADDER_EVENT, formatMoney } from '@theme/cp-ladder-ui';

const bar = document.querySelector('[data-cp-bar]');

if (bar) {
  const pause = bar.querySelector('[data-cp-bar-pause]');
  if (pause) {
    pause.addEventListener('click', function () {
      const paused = bar.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Продовжити зміну повідомлень' : 'Зупинити зміну повідомлень');
    });
  }

  const rotator = bar.querySelector('[data-cp-bar-rotator]');
  const ladder = bar.querySelector('[data-cp-bar-ladder]');
  const text = bar.querySelector('[data-cp-bar-text]');
  const cta = bar.querySelector('[data-cp-bar-cta]');

  /** Picks the one sentence that matches where the cart currently stands. */
  function sentenceFor(state, hasGiftLine) {
    const amount = formatMoney(state.toNext);

    switch (state.nextKind) {
      case 'shipping':
        return { text: bar.dataset.textToShipping.replace('%amount%', amount), cta: bar.dataset.ctaCart };
      case 'gift':
        // Delivery already free (three-level setup) or no delivery level at all.
        return {
          text: (state.t1 ? bar.dataset.textAfterShipping : bar.dataset.textToGift).replace('%amount%', amount),
          cta: bar.dataset.ctaCart,
        };
      case 'cheapest':
        return {
          text: bar.dataset.textAfterGift.replace('%amount%', amount),
          cta: hasGiftLine ? bar.dataset.ctaCart : bar.dataset.ctaChoose,
        };
      default:
        // Everything open. If the tee is still to be picked, say so.
        return {
          text: state.t2 && !hasGiftLine ? bar.dataset.textGiftOpen : bar.dataset.textAllUnlocked,
          cta: state.t2 && !hasGiftLine ? bar.dataset.ctaChoose : bar.dataset.ctaCart,
        };
    }
  }

  document.addEventListener(CP_LADDER_EVENT, function (event) {
    const state = event.detail.ladder;
    const cart = event.detail.cart;
    const isEmpty = !cart || !cart.item_count;

    bar.classList.toggle('cp-bar--ladder', !isEmpty);
    if (rotator) rotator.hidden = !isEmpty;
    if (ladder) ladder.hidden = isEmpty;

    if (isEmpty) return;

    const hasGiftLine = (cart.items || []).some(function (item) {
      return item.properties && item.properties._gift === 'true';
    });
    const copy = sentenceFor(state, hasGiftLine);

    if (text) text.textContent = copy.text;
    /*
     * Only the label changes; the arrow is a child node that must survive, so
     * the text is written into the leading text node rather than innerHTML.
     */
    if (cta && cta.firstChild) cta.firstChild.nodeValue = copy.cta + ' ';
  });

  if (ladder) {
    ladder.addEventListener('click', function () {
      const drawer = document.querySelector('cart-drawer-component');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      // No drawer on this template — the cart page is the honest fallback.
      window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
    });
  }
}
